module.exports = __webpack_public_path__ + "img/img01.773b1415.png";